import { enableProdMode } from '@angular/core';
import '@angular/localize/init';
import { bootstrapApplication } from '@angular/platform-browser';
import '@stripe/stripe-js';
import { environment } from 'shared/environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
